import { API, setAuthToken } from '../../../config/API.js';

export const getDataBeranda = () => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get(`admin/beranda`);
};

export const updDataBeranda = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/beranda/update", params);
};
